<template lang="pug">
.content-center
  .overlay
  //- small {{ defineOrder }}
  .item-group
    ul#sortable.list-group(data-role="listview")
      li.list-group-item(:id="index" v-for="index in order" :key="index")
        span.sort-pic
          img(:src="'images/light/sport/blue/' + getSportsImage(index)")
        span.sort-sport {{ sports[index] }}
        span.icon-sequence
</template>


<script>
import config from "@/config";

export default {
  data() {
    return {
      order: [],
      sortableInstance: null
    };
  },
  computed: {
    defineOrder() {
      return this.$store.state.layout.order.sports;
    },
    defaultOrder() {
      return Object.keys(this.$store.state.layout.sports);
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    sports() {
      return this.$store.state.layout.sports;
    }
  },
  mounted() {
    this.initilize();
    this.$nextTick(() => {
      const sortableEl = document.getElementById('sortable');
      if (sortableEl && window.Sortable) {
        this.sortableInstance = new window.Sortable(sortableEl, {
          animation: 150,
          ghostClass: 'sortable-ghost',
          dataIdAttr: 'id',
          onEnd: () => {
            this.updateSportsOrder(this.sortableInstance.toArray());
          }
        });
      }
    });
  },
  beforeDestroy() {
    if (this.sortableInstance) {
      this.sortableInstance.destroy();
      this.sortableInstance = null;
    }
  },
  methods: {
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    initilize() {
      if (this.defineOrder.length > 0) {
        this.order = this.defineOrder;
      } else {
        this.order = this.defaultOrder;
      }
    },
    updateSportsOrder(e) {
      this.order = e;
      this.save();
    },
    save() {
      this.$store
        .dispatch("user/setSettings", {
          page_display: JSON.stringify({
            language: this.pageDisplay.language,
            oddsType: this.pageDisplay.oddsType,
            pageType: this.pageDisplay.pageType,
            showScoreMap: this.pageDisplay.showScoreMap,
            eventSorting: this.pageDisplay.eventSorting,
            marketType: this.pageDisplay.marketType,
            pageSize: this.pageDisplay.pageSize,
            mmoType: this.pageDisplay.mmoType,
          }),
          sports_order: JSON.stringify(this.order),
          betting: JSON.stringify({
            defaultStake: this.betting.defaultStake,
            acceptBetterOdds: this.betting.acceptBetterOdds,
            acceptAnyOdds: this.betting.acceptAnyOdds,
            autoRefreshOdds: this.betting.autoRefreshOdds,
            quickBet: this.betting.quickBet,
            defaultStakeAmount: this.betting.defaultStakeAmount,
            quickBetAmount: this.betting.quickBetAmount,
          }),
        })
        .then(
          (res) => {
            this.$store.dispatch("layout/setOrder", { property: "sports", value: this.order }).then(
              (res) => {
                this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.succeed"), "success");
              },
              (err) => {
                this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
              }
            );
            this.initilize();
          },
          (err) => {
            this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
            this.initilize();
          }
        );
    }
  }
};
</script>
